module.exports = __webpack_public_path__ + "img/aa2.a284b96e.png";